


































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";

import { HsabExpenseReimbursementResponse, } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency.js";

@Component({
  components: {
    Widget
  }
})
export default class HsabExpenseReimbursementDenialReason extends Vue {
  formatCurrency = formatCurrency;
  formatDateString = formatMMddyyyyDateString;

  @Prop()
  reimbursement: HsabExpenseReimbursementResponse;

  get hasDenialReasons (): boolean {
    return this.reimbursement
        && this.reimbursement.denialReasons
        && this.reimbursement.denialReasons.length > 0;
  }

  get uploadDisallowed (): boolean {
    return this.reimbursement.denialReasons
        .some(x => !x.isUploadReceiptAllowed);
  }
}
